import React from 'react';
import woodpeckerSeoContent from './woodpeckerSeoContent.json';

const WoodpeckerMethodContent = () => {
  const { overview, stepsHeading, steps, online, audience, faqHeading, faq } = woodpeckerSeoContent;

  return (
    <section
      className="mx-auto mt-10 w-full max-w-5xl rounded-3xl border border-slate-200 bg-white px-5 py-8 text-left shadow-sm sm:px-8 sm:py-10"
      aria-labelledby="woodpecker-method-heading"
    >
      <div className="mx-auto max-w-3xl">
        <h2 id="woodpecker-method-heading" className="text-2xl font-bold text-slate-900 sm:text-3xl">
          {overview.heading}
        </h2>
        <div className="mt-4 space-y-4 text-base leading-7 text-slate-700">
          {overview.paragraphs.map((paragraph) => (
            <p key={paragraph} className="m-0">
              {paragraph}
            </p>
          ))}
        </div>
      </div>

      <div className="mx-auto mt-10 max-w-4xl">
        <h2 className="text-2xl font-bold text-slate-900">{stepsHeading}</h2>
        <ol className="mt-5 grid gap-4 md:grid-cols-2">
          {steps.map((step, index) => (
            <li key={step.title} className="rounded-2xl border border-slate-200 bg-slate-50 p-5">
              <div className="flex items-start gap-4">
                <span className="flex size-8 shrink-0 items-center justify-center rounded-full bg-sky-600 text-sm font-bold text-white">
                  {index + 1}
                </span>
                <div>
                  <h3 className="text-lg font-semibold text-slate-900">{step.title}</h3>
                  <p className="mt-2 text-sm leading-6 text-slate-700">{step.body}</p>
                </div>
              </div>
            </li>
          ))}
        </ol>
      </div>

      <div className="mx-auto mt-10 grid max-w-4xl gap-6 lg:grid-cols-2">
        <section className="rounded-2xl bg-slate-900 p-6 text-white">
          <h2 className="text-2xl font-bold">{online.heading}</h2>
          <div className="mt-4 space-y-4 text-sm leading-6 text-slate-200">
            {online.paragraphs.map((paragraph) => (
              <p key={paragraph} className="m-0">
                {paragraph}
              </p>
            ))}
          </div>
          <ul className="mt-5 space-y-3">
            {online.features.map((feature) => (
              <li key={feature} className="flex gap-3 text-sm leading-6 text-slate-100">
                <span className="mt-2 size-2 shrink-0 rounded-full bg-sky-400" aria-hidden="true" />
                <span>{feature}</span>
              </li>
            ))}
          </ul>
        </section>

        <section className="rounded-2xl border border-sky-100 bg-sky-50 p-6">
          <h2 className="text-2xl font-bold text-slate-900">{audience.heading}</h2>
          <p className="mt-4 text-sm leading-6 text-slate-700">{audience.paragraph}</p>
          <ul className="mt-5 space-y-3">
            {audience.points.map((point) => (
              <li key={point} className="flex gap-3 text-sm leading-6 text-slate-700">
                <span className="mt-2 size-2 shrink-0 rounded-full bg-sky-600" aria-hidden="true" />
                <span>{point}</span>
              </li>
            ))}
          </ul>
        </section>
      </div>

      <section className="mx-auto mt-10 max-w-4xl" aria-labelledby="woodpecker-faq-heading">
        <h2 id="woodpecker-faq-heading" className="text-2xl font-bold text-slate-900">
          {faqHeading}
        </h2>
        <div className="mt-5 divide-y divide-slate-200 rounded-2xl border border-slate-200">
          {faq.map((item) => (
            <article key={item.question} className="p-5 sm:p-6">
              <h3 className="text-lg font-semibold text-slate-900">{item.question}</h3>
              <p className="mt-2 text-sm leading-6 text-slate-700">{item.answer}</p>
            </article>
          ))}
        </div>
      </section>
    </section>
  );
};

export default WoodpeckerMethodContent;
